import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsErroredOrder {
  number: string;
  error?: string;
}

const useGetFieldAlyticsErroredOrders = (orderNumberFilter: string, options?: QueryOptions<FieldAlyticsErroredOrder[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  const urlParams = new URLSearchParams();
  if (orderNumberFilter) urlParams.append('orderNumberFilter', orderNumberFilter);
  return useUserOrEmployeeQuery<FieldAlyticsErroredOrder[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/erroredOrders?${urlParams.toString()}` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsErroredOrders;
